import React, { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { formatUSD } from '../../helpers/helperFunctions';
import { CaptionText, P1, P2 } from '../../styles/FontStyles';
import { Box, Flexed } from '../../styles/GlobalComponents';
import { color, lightTheme } from '../../styles/GlobalStyles';
import { TokenInfo } from './Airdrop.types';
import {
  AirdropHeaderItemMobile,
  AirdropItemMobile,
  BlurredValue,
  DisabledIcon
} from './AirdropsStyled';
import { Link } from 'react-router-dom';
import { SETTINGS_VIRTUAL_OFFICE } from '../../routes/routes';
import { Button, SidebarModal } from '../../components';
import {
  Icon,
  IconLock,
  IconTokenTelegram,
  IconTwitter,
  IconWebsite,
  InfoSmallIcon
} from '../../styles/Icons';

import dexscreener from '../../assets/images/backoffice/airDrop/dexscreener.png';
import website from '../../assets/images/backoffice/airDrop/website.png';
import Countdown from 'react-countdown';
import moment from 'moment';

interface AirdropItemProps {
  airdrop: TokenInfo;
  licence: boolean;
  key: number;
}

export const AirdropItemMobilee = ({
  airdrop,
  licence,
  key
}: AirdropItemProps) => {
  const [openModal, setOpenModal] = useState(false);
  const formatterCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    unitDisplay: 'short',
    // These options are needed to round to whole numbers if that's what you want.
    minimumFractionDigits: 7 // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  const CountdownComponent = (dateIso: any) => {
    const date = new Date(dateIso.dateIso);
    const timestamp = date.getTime();

    return (
      <Countdown
        date={timestamp}
        renderer={({ days, hours, minutes }) => (
          <>
            <b>
              {days}D {hours}H {minutes}M
            </b>
          </>
        )}
      />
    );
  };
  return (
    <>
      <Box>
        <AirdropHeaderItemMobile
          style={{
            alignItems: 'center',
            borderBottom: '1px solid rgba(220, 220, 220)'
          }}>
          <img
            src={airdrop.image}
            alt='token'
            style={{ width: '40px', marginRight: 10 }}
          />
          {airdrop.name}
        </AirdropHeaderItemMobile>

        <AirdropItemMobile
          data-tip
          data-for={'airdrop-tooltip-licence' + key}
          onClick={() => {
            licence && setOpenModal(!openModal);
          }}
          style={{ cursor: licence ? 'pointer' : 'default' }}>
          <Flexed between width='100%'>
            <div style={{ width: 25 }}></div>
            <div>
              <P2 color={lightTheme.colors.neutral500}>Your Tokens</P2>
            </div>
            <Flexed column center>
              <Icon>
                <IconLock />
              </Icon>
            </Flexed>
          </Flexed>
          <Flexed between width='100%'>
            <div style={{ width: 25 }}></div>
            <div>
              <BlurredValue blurred={licence}>
                <P1>
                  {' '}
                  {airdrop.tokenAmount !== '/'
                    ? formatUSD(Number(airdrop.tokenAmount))
                    : '/'}
                </P1>
              </BlurredValue>

              {!licence && (
                <P1 mt='8' color={color.colors.primary900}>
                  View Tokens
                </P1>
              )}
            </div>

            <Flexed column center mr='4'>
              <InfoSmallIcon disabled={false} />
            </Flexed>
          </Flexed>
        </AirdropItemMobile>

        <Flexed wrap>
          <AirdropItemMobile>
            <P2 color={lightTheme.colors.neutral500}>Price</P2>
            <P1>
              {airdrop.price !== '/'
                ? formatterCurrency.format(Number(airdrop.price))
                : airdrop.price}
            </P1>
          </AirdropItemMobile>

          <AirdropItemMobile>
            <P2 color={lightTheme.colors.neutral500}>Total Value</P2>{' '}
            <P1>
              {airdrop.totalValue !== '/'
                ? formatterCurrency.format(Number(airdrop.totalValue))
                : airdrop.totalValue}
            </P1>
          </AirdropItemMobile>
        </Flexed>
        <Flexed>
          <AirdropItemMobile style={{ marginRight: 5 }}>
            <P2 color={lightTheme.colors.neutral500}>Website</P2>

            <img src={website} style={{ width: 43 }} />
          </AirdropItemMobile>
          <AirdropItemMobile>
            <P2 color={lightTheme.colors.neutral500}>X</P2>

            <a
              href={`https://x.com/kimba_meme`}
              target='_blank'
              rel='noreferrer'>
              <DisabledIcon>
                <Icon>
                  <IconTwitter />
                </Icon>
              </DisabledIcon>
            </a>
          </AirdropItemMobile>
        </Flexed>
        <Flexed>
          <AirdropItemMobile style={{ marginRight: 5 }}>
            <P2 color={lightTheme.colors.neutral500}>Telegram</P2>
            <a
              href={`https://t.me/KIMBA_THE_WHITE_LION_official`}
              target='_blank'
              rel='noreferrer'>
              <Icon>
                <IconTokenTelegram />
              </Icon>
            </a>
          </AirdropItemMobile>
          <AirdropItemMobile>
            <P2 color={lightTheme.colors.neutral500}>Dextools</P2>

            <a
              href={`https://www.dextools.io/app/en/token/kimba?t=1733224330154`}
              target='_blank'
              rel='noreferrer'>
              <DisabledIcon>
                <img src={dexscreener} style={{ width: 43 }} />
              </DisabledIcon>
            </a>
          </AirdropItemMobile>
        </Flexed>
      </Box>

      {!licence && (
        <ReactTooltip
          clickable
          id={'airdrop-tooltip-licence' + key}
          place='top'
          effect='solid'
          backgroundColor='#fff'
          delayHide={200}>
          <div style={{ width: 200 }}>
            <CaptionText color={color.colors.neutral500} semiBold mb='8'>
              To unlock your accumulated tokens you need to have a paid
              Back-Office subscription.
            </CaptionText>
            <Link to={SETTINGS_VIRTUAL_OFFICE}>
              <Button>Get BO Subscription</Button>
            </Link>
          </div>
        </ReactTooltip>
      )}

      <SidebarModal
        isOpen={openModal}
        setOpen={setOpenModal}
        title={`KIMBA Airdrops Details`}
        sidebarWidth={'600px'}>
        {airdrop?.airdrops?.map((airdropItem, index) => {
          return (
            <Box key={index}>
              <AirdropHeaderItemMobile
                style={{
                  alignItems: 'center',
                  borderBottom: '1px solid rgba(220, 220, 220)'
                }}>
                <img
                  src={airdrop.image}
                  alt='token'
                  style={{ width: '40px', marginRight: 10 }}
                />
                {airdrop.name}
              </AirdropHeaderItemMobile>

              <Flexed wrap>
                <AirdropItemMobile>
                  <P2 color={lightTheme.colors.neutral500}>Amount</P2>
                  <P1>{formatUSD(Number(airdropItem.tokenAmount))}</P1>
                </AirdropItemMobile>
                <AirdropItemMobile>
                  <P2 color={lightTheme.colors.neutral500}>Unlocked In</P2>
                  <CountdownComponent dateIso={airdropItem.unlockDate} />
                </AirdropItemMobile>
              </Flexed>
              <Button
                mt='10'
                w='100px'
                h='34px'
                disabled={true}
                onClick={() => {}}>
                Claim
              </Button>
            </Box>
          );
        })}
      </SidebarModal>
    </>
  );
};
